import { useEffect } from 'react';
import { getAppUrl } from '@drayalliance/utils';

function ChassisPoolsManagement() {
  useEffect(() => {
    window.location.assign(`${getAppUrl(window.location.hostname, 'dms', 3001)}/tools/chassis-pool-management`);
  }, []);

  return null;
}

export default ChassisPoolsManagement;
